<script lang="ts" setup>
import { Button } from '~ds/components/ui/button';
import { Heading, Text } from '~ds/components/ui/typography';
import { useI18n } from 'vue-i18n';

interface Props {
  helpText?: string;
}

withDefaults(defineProps<Props>(), {
  helpText: '',
});

const emit = defineEmits<{
  back: [];
}>();

const { t } = useI18n();
</script>

<template>
  <div
    class="flex flex-col items-center"
    data-testid="auth-register-disabled-step"
  >
    <Heading
      size="xl"
      as="h1"
      class="text-center mb-3"
    >
      {{ t('kui.auth.accessDenied') }}
    </Heading>
    <Text
      v-if="helpText"
      size="lg"
      class="text-center"
      data-testid="auth-register-disabled-help"
    >
      {{ helpText }}
    </Text>
    <Button
      class="mt-6"
      size="sm"
      type="button"
      data-testid="auth-register-disabled-back"
      @click="emit('back')"
    >
      {{ t('kui.auth.loginWithAnotherEmail') }}
    </Button>
  </div>
</template>
